import { useLocationContext } from '../context/useLocationContext';

export function useLocation() {
  return useLocationContext();
}
